import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Content, Paper, Toolbar, Tabs, Tab, TabPanel } from './../../../components/ui';
import { hasPermission } from './../../../utilities/utils';
import LeadList from './../../lead/list';
import ShippingOrderList from './../../shipping/order/list';

import API from './../../../config/api';

class DashboardTracking extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      section: 0
    };
  }

  /*
  ** @Event
  ** @Description: Change tab
  */

  handleChangeSection = (event: React.ChangeEvent<{}>, index: number) => {
    this.setState({ section: index });
  }

  render(){

    const { session, t } = this.props;
    const { section } = this.state;

    return (
      <Content disablePadding>

        <Toolbar
          title={t('text.tracing')}
          subtitle={t('text.last_ten_changes')}
          size="medium"
        />

        <Paper disablePadding>
          <Tabs
            divider
            value={ section }
            onChange={this.handleChangeSection}
          >
            { hasPermission(session.user.permissions, API.permissions.leads) && (
              <Tab label={t('text.leads')}/>
            )}
            { hasPermission(session.user.permissions, API.permissions.shipping) && (
              <Tab label={t('text.reservations')}/>
            )}
          </Tabs>

          { hasPermission(session.user.permissions, API.permissions.payments) && (
            <TabPanel value={ section } index={0}>
              <LeadList/>
            </TabPanel>
          )}
          { hasPermission(session.user.permissions, API.permissions.shipping) && (
            <TabPanel value={ section } index={1}>
              <ShippingOrderList/>
            </TabPanel>
          )}
        </Paper>

      </Content>
    )
  }

};

const mapStateToProps = (state) => {
  return {
    session: state.userState
  }
};

export default withTranslation()(connect(mapStateToProps)(DashboardTracking));
